import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { toast } from 'react-toastify'
import Alert from '../alert'
import { translate } from '../../helpers/stringHelpers'
import * as Sentry from '@sentry/browser'
import Button from '../button'

export class ElementErrorBoundary extends Component {
  constructor (props) {
    super(props)
    this.state = { hasError: false, eventId: null, children: this.props.children }
  }

  componentDidCatch (error) {
    this.setState({ hasError: true })
    console.warn(`${error.message}, this is possibly related to a translator browser plugin or other browser plugin`)
    toast.warn('The translation plugin you are using could not translate some of the items.', { toastId: 'translation-plugin-warning' })
  }

  componentDidUpdate (prevProps) {
    if (prevProps.children !== this.props.children) {
      this.setState({ hasError: false })
    }
  }

  render () {
    if (this.state.hasError && !this.props.children) {
      const handleFeedbackClick = () => Sentry.showReportDialog({ eventId: this.state.eventId })
      // Will cause the item to be replaced with a warning
      return (
        <div>
          <Alert color='warning'>{translate('JSTextCodes_RELOAD_MESSAGE')}</Alert>
          <Button
            color='info'
            onClick={handleFeedbackClick}
          >
            Report feedback
          </Button>
        </div>
      )
    }
    return this.props.children
  }
}

ElementErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired
}

export default ElementErrorBoundary
